/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type EmailNotificationTableFragment = { __typename: 'NotificationSettingsModel', id: string, settings: Array<{ __typename: 'NotificationItem', status: Types.NotificationStatus, alertType: Types.NotificationAlertType, reminderType: Types.NotificationReminderType, notificationType: Types.NotificationType }> };

export const EmailNotificationTableFragmentDoc = gql`
    fragment EmailNotificationTable on NotificationSettingsModel {
  id
  settings {
    status
    alertType
    reminderType
    notificationType
  }
}
    `;